import { Table } from 'antd'
import React from 'react'

export default function DivisionPreviewTable({ data, blank }) { 
  return (
      <Table dataSource={data} rowKey={(r) => r.id}>
          <Table.Column title="Name" key="name" dataIndex="name" />
          <Table.Column title="Short Code" key="short_code" dataIndex={!blank ? "short_code" : ''} />
          <Table.Column title="Code" key="code" dataIndex={!blank ? "code" : ''} />
          <Table.Column title="Batch Group" key="batch_group" dataIndex={!blank ? "batch_group" : ''} />
      </Table>
  )
}